<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="tempDomainModal" tabindex="-1" role="dialog" aria-labelledby="notesModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader"> {{ domain }} {{ (ip) ? `(${ip})` : ''}} </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div v-if="loading" class="modal-body">
            <div class="loader"></div>
          </div>
          <div v-else class="modal-body">
            <div v-if="result" class="row">
              <div class="col-12">
                <b style="font-size: 20px">Temp Domain: <small>
                  <a :href="`https://${result.tempDomain}`" target="_blank"><span style="font-size: 20px">{{result.tempDomain}}</span></a>
                  <a @click="doCopy(result.tempDomain)" v-clipboard:copy="result.tempDomain" class="ml-5" href="javascript:void(0)"><i class="fa fa-copy"></i></a>
                </small>
                </b>
              </div>
              <div class="col-12" v-if="result.docId">
                <button type="button" @click="removeTemp(result.docId)"  class="btn btn-sm btn-primary" style="float:right; margin-bottom: 20px;">
                  <div class="loader" v-if="deleting" style="width: 15px;height: 15px; margin: 0 !important;"></div>
                  <span v-else>
                    Remove
                  </span>
                </button>
              </div>
            </div>
            <div v-else>
              <form @submit.prevent="createNewTempLink">
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-12">
                      <label>Expiry Time</label>
                    </div>
                    <div class="col-md-4">
                      <select class="form-control" v-model="newLink.expiryTime">
                        <option value="10">10 minutes</option>
                        <option value="30">30 minutes</option>
                        <option value="60">1 hour</option>
                        <option value="1440">24 hours</option>
                        <option value="permanent">Permanent</option>
                        <option value="custom">Custom</option>
                      </select>
                    </div>
                    <div class="col-md-4" v-if="newLink.expiryTime === 'custom'">
                      <input type="number" required v-model="newLink.value" class="form-control">
                    </div>
                    <div class="col-md-4" v-if="newLink.expiryTime === 'custom'">
                      <select class="form-control" v-model="newLink.unit">
                        <option value="hours">Hours</option>
                        <option value="days">Days</option>
                        <option value="minutes">Minutes</option>
                      </select>
                    </div>
                    <div class="col-md-12 text-right">
                      <button type="submit" class="btn btn-primary" :disabled="adding || !domain || !ip">
                        <div class="loader small_loader" style="height: 20px; width: 20px" v-if="adding"></div>
                        <span v-else>Submit</span>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import {db} from "@/firebase/init"
import swal from "sweetalert2";

export default {
  name: "showTempDomainModal",

  data () {
    return {
      domain: '',
      ip: '',
      uid: '',
      loading: false,
      adding: false,
      deleting: false,
      result: null,
      alreadyExists: false,
      newLink: {
        expiryTime: '30',
        value: 5,
        unit: 'hours',
      },
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    doCopy(item){
      this.$copyText(item).then(() => {
        this.$notify({
          group: 'foo',
          title: 'Message',
          text: 'Copied!'
        });
      }, function (e) {
        console.log(e)
      });
    },
    async load (data) {
      console.log(data)
      this.domain = data.domain
      this.ip = data.ip || ''
      this.uid = data.uid || ''
      const expiry = data.expiryTime || '30'
      $('#tempDomainModal').modal('show');
      this.result = null
      this.newLink = {
        expiryTime: expiry,
        value: 5,
        unit: 'hours',
      }
      this.adding=false;
      this.deleting=false;
      this.loading=true;
      await this.viewTempDomain()

      this.loading=false;
    },
    async viewTempDomain(){
      try {
        if (!this.ip && this.uid) {
          const ref = await db.collection('domains').where('domain', '==', this.domain).where('uid', '==', this.uid).get();
          if(ref.size) {
            console.log(ref.docs[0].data())
            this.ip = ref.docs[0].data().ip
            console.log('ip',this.ip)
          }
        }
        console.log('checking already exists')
        const ref1 = await db.collection('temp-domains').where('liveDomain', '==', this.domain).where('ip', '==', this.ip).get();
        if(ref1.size) {
          this.alreadyExists = true
          console.log('already exists')
          const data = ref1.docs[0].data()
          this.result = { ...data, docId: ref1.docs[0].id }
        }
      } catch (e) {
        console.log(e)
      }
    },
    async createNewTempLink () {
      try {
        this.adding = true
        const resp = await this.$http.post('utilities/create_temp_link', {
          grant_type: 'token',
          uid: this.uid,
          domain: this.domain,
          ip: this.ip,
          createdBy: this.user.firstName + ' ' + this.user.lastName,
          expiryTime: this.newLink.expiryTime,
          value: this.newLink.value,
          unit: this.newLink.unit,
        });
        this.newLink = {
          expiryTime: '30',
          value: 5,
          unit: 'hours',
        }
        this.result = resp.data.data
      } catch (e) {
        swal({
          title: "Error",
          text: 'Error in creating Temp link',
          type: "error",
        });
      }
      this.adding = false
    },
    async removeTemp(docId){
      try {
        this.deleting = true
        try {
          await this.$http.post('utilities/remove_temp_link', {
            grant_type: 'token',
            docId,
            domain: this.domain,
          });
          this.result = null
          swal({
            title: "Success",
            text: 'Successfully deleted this temp domain!',
            type: "success",
          });
          $('#tempDomainModal').modal('hide');
        } catch (e) {
          console.log(e)
          swal({
            title: "Error",
            text: 'Error in deleting this temp domain!',
            type: "error",
          });
        }
        this.deleting = false
      } catch (e) {
        console.log(e)
      }
    },
  }
}
</script>

<style scoped>
.row.macro {
  padding: 10px;
  margin-bottom: 2px;
  border: 1px solid #9b9696;
}
</style>
